import $ from "jquery";

const formLoginRegister = () => {
  const init = () => {
    switchForm();
    checkPasswordMatch();
  };

  const switchForm = () => {
    const el = {
      button: ".js-changeForm",
      parentClass: ".AccountPage__LoginRegister__Left",
      formLogin: "#login-form",
      formRegister: "#register-form",
    };

    if ($(el.parentClass).length === 0) return;

    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      $(el.parentClass).removeClass('active');

      const nextTab = $(this).data("for");
      $(`#${nextTab}`).addClass('active');
    });
  };

  const checkPasswordMatch = () => {
    const el = {
      parentClass: ".AccountPage__LoginRegister__Left",
      passwordMessage: ".password-message",
      passwordInput: ".AccountPage__LoginRegister__Left__Form__Password #reg_password",
      repeatPasswordInput: ".AccountPage__LoginRegister__Left__Form__Password #reg_password_repeat",
    };

    if ($(el.parentClass).length === 0) return;

    $(el.passwordInput).on("input", function () {
      if ($(el.repeatPasswordInput).val() != '') {
        if ($(this).val() !== $(el.repeatPasswordInput).val()) {
          $(this).siblings(el.passwordMessage).show();
        }
        else {
          $(el.passwordMessage).hide();
        }
      }
    });
    $(el.repeatPasswordInput).on("input", function () {
      if ($(this).val() !== $(el.passwordInput).val()) {
        $(this).siblings(el.passwordMessage).show();
      }
      else {
        $(el.passwordMessage).hide();
      }
    });
  };



  init();
};

try {
  formLoginRegister();
} catch (error) {
  console.error("formLoginRegister: ", error);
}
